import TreeTable from "./TreeTable.jsx";

export default TreeTable;



// WEBPACK FOOTER //
// ./src/components/pages/MyUniverse/treeTable/index.js